/** Accept legacy checkpoint settings while keeping live workload numeric. */
export function normalizeWorkload(value: unknown): number {
  if (value === "ECO") return 1;
  if (value === "BALANCED") return 4;
  if (value === "PERFORMANCE") return 16;
  if (typeof value !== "number" || !Number.isInteger(value) || value < 1 || value > 64) {
    throw new Error("INVALID_MINING_WORKLOAD");
  }
  return value;
}
